import React from 'react';
import PropTypes from 'prop-types';

import { Message, Icon } from '@weezevent/nacre';
import Style from './custom-message.module.css';

export default function CustomMessage({ title, icon, children }) {
    return (
        <Message className={Style['message-custom-icon']} type="default">
            <Icon name={icon} size="huge" color="ticket" />
            <div className="wz-message-content">
                <div className="wz-message-title">{title}</div>
                <div className="wz-message-message">{children}</div>
            </div>
        </Message>
    );
}

CustomMessage.propTypes = {
    title: PropTypes.string.isRequired,
    icon: PropTypes.object.isRequired
};
